"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useRateClsByApp = void 0;
const tslib_1 = require("tslib");
const nnq_1 = tslib_1.__importDefault(require("@futuweb/tool-nn/dist/nnq"));
const browser = tslib_1.__importStar(require("@futuweb/tool-browser"));
const vue_demi_1 = require("vue-demi");
/**
 * 获取 app 配置的涨跌色，返回 redup 或 reddown，一般用来作为外层容器的 classname 来控制涨跌色类型
 * @param {Boolean} followApp 是否跟随 app 配置涨跌色，false 时直接返回第二个参数或 redup
 * @param {String} defaultRateColor 默认涨跌色，客户端不支持的情况下返回默认值 或 redup
 * @returns {String} 返回 'redup' 或 'reddown'
 */
const useRateClsByApp = (followApp, defaultRateColor) => {
    const rateColorCls = (0, vue_demi_1.ref)(`quotes-color-${defaultRateColor || 'redup'}`);
    if (!followApp) {
        return rateColorCls;
    }
    // 客户端不支持的话，直接返回默认值，安卓和ios刚好同版本发布 12.43.8908开始支持
    if (!browser.isMobileNN() || !browser.laterThanClient({ isXYZFormat: true, ver: '12.43.8908' })) {
        return rateColorCls;
    }
    nnq_1.default.initBridge({}, () => {
        window.NNWebViewJSBridge.callHandler('getUpDownType', {}, (res) => {
            try {
                const ret = JSON.parse(res); // result: 0 成功， -1失败
                if (ret && ret.result === 0) {
                    const rate = Number(ret.data || 0);
                    if (rate === 0 || rate === 2) {
                        rateColorCls.value = 'quotes-color-redup';
                    }
                    else {
                        rateColorCls.value = 'quotes-color-reddown';
                    }
                    //data:涨跌色，0红涨绿跌，1绿涨红跌，2色盲色涨色（粉涨绿跌），3色盲色跌色（绿涨粉跌）
                }
            }
            catch (e) {
                console.error(e);
            }
        });
    });
    return rateColorCls;
};
exports.useRateClsByApp = useRateClsByApp;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicmF0ZUJ5QXBwLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsicmF0ZUJ5QXBwLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7QUFBQSw0RUFBNEM7QUFDNUMsdUVBQWlEO0FBQ2pELHVDQUErQjtBQUUvQjs7Ozs7R0FLRztBQUNJLE1BQU0sZUFBZSxHQUFHLENBQUMsU0FBUyxFQUFFLGdCQUFnQixFQUFFLEVBQUU7SUFDM0QsTUFBTSxZQUFZLEdBQUcsSUFBQSxjQUFHLEVBQUMsZ0JBQWdCLGdCQUFnQixJQUFJLE9BQU8sRUFBRSxDQUFDLENBQUM7SUFFeEUsSUFBSSxDQUFDLFNBQVMsRUFBRSxDQUFDO1FBQ2IsT0FBTyxZQUFZLENBQUM7SUFDeEIsQ0FBQztJQUVELGdEQUFnRDtJQUNoRCxJQUFJLENBQUMsT0FBTyxDQUFDLFVBQVUsRUFBRSxJQUFJLENBQUMsT0FBTyxDQUFDLGVBQWUsQ0FBQyxFQUFFLFdBQVcsRUFBRSxJQUFJLEVBQUUsR0FBRyxFQUFFLFlBQVksRUFBRSxDQUFDLEVBQUUsQ0FBQztRQUM5RixPQUFPLFlBQVksQ0FBQztJQUN4QixDQUFDO0lBRUQsYUFBRyxDQUFDLFVBQVUsQ0FBQyxFQUFFLEVBQUUsR0FBRyxFQUFFO1FBQ3BCLE1BQU0sQ0FBQyxpQkFBaUIsQ0FBQyxXQUFXLENBQUMsZUFBZSxFQUFFLEVBQUUsRUFBRSxDQUFDLEdBQUcsRUFBRSxFQUFFO1lBQzlELElBQUksQ0FBQztnQkFDRCxNQUFNLEdBQUcsR0FBRyxJQUFJLENBQUMsS0FBSyxDQUFDLEdBQUcsQ0FBQyxDQUFDLENBQUMscUJBQXFCO2dCQUNsRCxJQUFJLEdBQUcsSUFBSSxHQUFHLENBQUMsTUFBTSxLQUFLLENBQUMsRUFBRSxDQUFDO29CQUMxQixNQUFNLElBQUksR0FBRyxNQUFNLENBQUMsR0FBRyxDQUFDLElBQUksSUFBSSxDQUFDLENBQUMsQ0FBQztvQkFDbkMsSUFBSSxJQUFJLEtBQUssQ0FBQyxJQUFJLElBQUksS0FBSyxDQUFDLEVBQUUsQ0FBQzt3QkFDM0IsWUFBWSxDQUFDLEtBQUssR0FBRyxvQkFBb0IsQ0FBQztvQkFDOUMsQ0FBQzt5QkFBTSxDQUFDO3dCQUNKLFlBQVksQ0FBQyxLQUFLLEdBQUcsc0JBQXNCLENBQUM7b0JBQ2hELENBQUM7b0JBQ0QsZ0RBQWdEO2dCQUNwRCxDQUFDO1lBQ0wsQ0FBQztZQUFDLE9BQU8sQ0FBQyxFQUFFLENBQUM7Z0JBQ1QsT0FBTyxDQUFDLEtBQUssQ0FBQyxDQUFDLENBQUMsQ0FBQztZQUNyQixDQUFDO1FBQ0wsQ0FBQyxDQUFDLENBQUM7SUFDUCxDQUFDLENBQUMsQ0FBQztJQUVILE9BQU8sWUFBWSxDQUFDO0FBQ3hCLENBQUMsQ0FBQztBQWhDVyxRQUFBLGVBQWUsbUJBZ0MxQiJ9